import { type ReactNode } from "react";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import ScrollToTop from "@/components/feature/ScrollToTop";

export default function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <ScrollToTop />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}